/* eslint-disable react/jsx-no-comment-textnodes */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { HashLink as Link } from "react-router-hash-link";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import RedesComponent from "../../utilerias/redesSociales";
import "./styles.css";

const MenuComponent = (props) => {
  // const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  // if (isSafari === true) {
  //   const enlaces = document.getElementsByClassName("enlace-safari");
  //   if (enlaces.length > 1) {
  //     for (let i = 0; i < enlaces.length; i++) {
  //       const enlace = enlaces[i];
  //       enlace.classList = "imagen-opcion-menu enlace-safari safari-link";
  //     }
  //   }
  // }
  return (
    <Fragment>
      <div id="myNav" className="overlay">
        <Container fluid>
          <Row>
            <Col className="encabezado-movil" md={12}></Col>
          </Row>
          <Row>
            <Col md={12} lg={2}></Col>
            <Col className="col-opciones-menu" md={12} lg={4}>
              <div className="menu-opcion">
                <div className="imagen-opcion-menu enlace-safari">
                  <div className="img-contenedor">
                    <div className="opcion-menu-texto">
                      <small> / / /</small>
                      <div>
                        <Link className="enlace-safari" to="/" onClick={() => props.closeNav()}>
                          {props.cambiarIdioma
                            ? <span>¿quién es jack?</span>
                            : <span>who is jack?</span>}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col className="col-opciones-menu" md={12} lg={4}>
              <div className="menu-opcion">
                <div className="imagen-opcion-menu enlace-safari">
                  <div className="img-contenedor">
                    <div className="opcion-menu-texto">
                      <small> / / /</small>
                      <div>
                        <Link className="enlace-safari" to="/servicios" onClick={() => props.closeNav()}>
                          {props.cambiarIdioma ? <span>servicios</span> : <span>services</span>}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={12} lg={2}></Col>
          </Row>
          <Row>
            <Col md={12} lg={2}></Col>
            <Col className="col-opciones-menu" md={12} lg={4}>
              <div className="menu-opcion">
                <div className="imagen-opcion-menu enlace-safari">
                  <div className="img-contenedor">
                    <div className="opcion-menu-texto">
                      <small> / / /</small>
                      <div>
                        <Link className="enlace-safari" to="/galeria" onClick={() => props.closeNav()}>
                          {props.cambiarIdioma
                            ? <span>jack en acción</span>
                            : <span>jack in action</span>}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col className="col-opciones-menu" md={12} lg={4}>
              <div className="menu-opcion">
                <div className="imagen-opcion-menu enlace-safari">
                  <div className="img-contenedor">
                    <div className="opcion-menu-texto">
                      <small> / / /</small>
                      <div>
                        <Link className="enlace-safari" to="/contacto" onClick={() => props.closeNav()}>
                          {props.cambiarIdioma ? <span>contáctalo</span> : <span>contact him</span>}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={12} lg={2}></Col>
          </Row>
          <Row>
            <Col md={12} lg={2}></Col>
            <Col className="col-opciones-menu" md={12} lg={4}>
              <div className="menu-opcion">
                <div className="imagen-opcion-menu enlace-safari">
                  <div className="img-contenedor">
                    <div className="opcion-menu-texto">
                      <small> / / /</small>
                      <div>
                        <a
                          className="enlace-safari"
                          href="https://www.blog.wearejack.mx/"
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={() => props.closeNav()}
                        >
                          {props.cambiarIdioma ? <span>notas de jack</span> : <span>jack notes</span>}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col className="col-opciones-menu" md={12} lg={4}>
              <div className="menu-opcion">
                <div className="imagen-opcion-menu enlace-safari">
                  <div className="img-contenedor">
                    <div className="opcion-menu-texto">
                      <small> / / /</small>
                      <div>
                        <Link className="enlace-safari" to="/preguntas" onClick={() => props.closeNav()}>
                          {props.cambiarIdioma
                            ? <Fragment><span>preguntas</span> <span>frecuentes</span></Fragment>
                            : <span>FAQ's</span>}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={12} lg={2}></Col>
          </Row>
          <Row>
            <RedesComponent></RedesComponent>
          </Row>
        </Container>
      </div>
    </Fragment>
  );
};

MenuComponent.propTypes = {
  cambiarIdioma: PropTypes.bool,
  closeNav: PropTypes.func,
};

export default MenuComponent;
